<template>
  <div class="wait-audio-player w-100 justify-content-end d-flex">
    <div class="controls mt-3 d-flex align-items-center">
      <div class="col-12 text-end">
        <img :src="audioicon" />
      </div>
    </div>
  </div>
</template>
<script>
import { ref } from "vue";

export default {
  name: "WaitAudio",

  setup() {
    const assetUrl = process.env.VUE_APP_ASSET_URL;
    const audioicon = ref(`${assetUrl}/img/wait-audio.gif`);

    return {
      audioicon,
    };
  },
};
</script>
